const content = {
    itv_account_validation_from_card: {
        en: {
            summary_no_video_html: `<p>Please upload a photo of your Sky card:</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `<p>Take a photo of the front of your card with the 9-digit number clearly visible.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `<p>Upload using the controls below.</p>`
                }
            ],
            finished_steps_text: 'I have followed the steps above and my card is clear and visible',
        }
    },
    itv_account_validation_from_app: {
        en: {
            summary_no_video_html: `<p>Please upload a screenshot of your account screen:</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `<p>Take a screenshot as per the previous instructions with your account number clearly visible.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `<p>Upload using the controls below.</p>`
                }
            ],
            finished_steps_text: 'I have followed the steps above and my account number is clear and visible',
        }
    },
    itv_account_validation_from_youview: {
        en: {
            summary_no_video_html: `<p>Please upload a photo of your television screen:</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `<p>Take a photo of your television screen with serial number clearly visible.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `<p>Upload using the controls below.</p>`
                }
            ],
            finished_steps_text: 'I have followed the steps above and my card is clear and visible',
        }
    },
}

export const itvDataTypes = {
    itv_account_validation_from_card: {
        data_type: 'itv_account_validation_from_card',
        data_type_description: 'ITV Account',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/itv/logo.png',
        capture_type: 'image',
        require_consent: true,
        generic: {
            ...content.itv_account_validation_from_card
        }
    },
    itv_account_validation_from_app: {
        data_type: 'itv_account_validation_from_app',
        data_type_description: 'ITV Account',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/itv/logo.png',
        capture_type: 'image',
        require_consent: true,
        generic: {
            ...content.itv_account_validation_from_app
        }
    },
    itv_account_validation_from_youview: {
        data_type: 'itv_account_validation_from_youview',
        data_type_description: 'ITV Account',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/itv/logo.png',
        capture_type: 'image',
        require_consent: true,
        generic: {
            ...content.itv_account_validation_from_youview
        }
    },
}